
























import { defineComponent } from '@nuxtjs/composition-api';

export type FeatureDetailWithColumns = Blok & {
  title: string;
  description: string;
  markedText: string;
  markedTextColor: string;
  media: Blok[];
  columns: Blok[];
  marginBottom: number;
  titleMaxWidth: number;
  descriptionMaxWidth: number;
};

export default defineComponent({
  props: {
    blok: { type: Object as () => FeatureDetailWithColumns, required: true },
  },
  computed: {
    hasMedia(): boolean {
      return !!this.blok?.media?.length;
    },
    hasTextContent(): boolean {
      return !!(
        this.blok?.title ||
        this.blok?.description ||
        this.blok?.markedText
      );
    },

    hasMarkedText(): boolean {
      return !!this.blok?.markedText?.length;
    },
    hasColumns(): boolean {
      return !!this.blok?.columns?.length;
    },
    cssVars(): CSSVars {
      return {
        '--margin-bottom': this.blok.marginBottom
          ? `${this.blok.marginBottom}rem`
          : 0,
        '--title-max-width': this.blok.titleMaxWidth
          ? `${this.blok.titleMaxWidth}ch`
          : '100%',
        '--description-max-width': this.blok.descriptionMaxWidth
          ? `${this.blok.descriptionMaxWidth}ch`
          : '100%',
      };
    },
  },
});
